export const GUEST_CAMPAIGN_FORM = '[GuestCampaignForm]';

export const GUEST_CREATE_CAMPAIGN_REQUEST = `${GUEST_CAMPAIGN_FORM} GUEST_CREATE_CAMPAIGN_REQUEST`;
export const REMOVE_TEMPORARY_CAMPAIGN_FORM_DATA = `${GUEST_CAMPAIGN_FORM} REMOVE_TEMPORARY_CAMPAIGN_FORM_DATA`;
